export default function calcularTotales(form, tarifas, tasaCambio = 4500) {

  const cantidadUnidades = Number(form.unidadesHabitacionales) || 0;

  function calcularPrecioPorUnidades(unidades, tarifas) {
    if (!tarifas) return 0;
    if (unidades <= 20) return tarifas.Maquetas20 || 0;
    if (unidades <= 50) return tarifas.Maquetas50 || 0;
    if (unidades <= 100) return tarifas.Maquetas100 || 0;
    if (unidades <= 150) return tarifas.Maquetas150 || 0;
    if (unidades <= 200) return tarifas.Maquetas200 || 0;
    if (unidades <= 300) return tarifas.Maquetas300 || 0;
    if (unidades <= 500) return tarifas.Maquetas500 || 0;
    if (unidades <= 1000) return tarifas.Maquetas1000 || 0;
    if (unidades <= 1500) return tarifas.Maquetas1500 || 0;
    return tarifas.Maquetas1500 || 0;
  }

  // Precio por unidades habitacionales (si aplica)
  const precioCOPUnidades = cantidadUnidades > 0 ? calcularPrecioPorUnidades(cantidadUnidades, tarifas) : 0;

  // Wire Transfer Fee en COP (si aplica)
  const tarifaTransferenciaCOP =
    tarifas?.WireTransferFee && form.unidadesHabitacionales > 0
      ? Number(tarifas.WireTransferFee)
      : 0;

  // Base para cálculo del proveedor tecnológico
  const baseParaServicioTerceros = precioCOPUnidades + tarifaTransferenciaCOP;

  // % administración sobre base anterior
  const porcentajeAdmin = tarifas?.PorcentajeAdministracionServicoTerceros || 0;

  const precioSitioWebCOP = Math.round(
    baseParaServicioTerceros * (1 + porcentajeAdmin / 100)
  );

  const totalMaquetaCalculado =
    ((tarifas?.AnimacionIntro || 0) * (form.animacionIntro || 0)) +
    ((tarifas?.VideoAnimacion || 0) * (form.videoAnimacion || 0)) +
    (tarifas?.AnimacionVueloATorre || 0) * (form.vueloTorre * form.numeroTorres || 0) +
    (tarifas?.RendersStillsParaDisponiblidad || 0) * (form.rendersDisponibilidad * form.numeroTorres || 0) +
    ((tarifas?.AnimacionParaLumaIA || 0) * (form.animacionLuma || 0)) +
    (form.incluirVueloDrone ? (Number(form.vueloDrone) || 0) : 0);

  const costoServicioMasComision = Math.round(
    (totalMaquetaCalculado || 0) * ((tarifas?.PorcentajeComision || 0) / 100)
  );

  const ComisionFinal = costoServicioMasComision - totalMaquetaCalculado;

  // Precio anual de mantenimiento en COP
  const precioAnualMantenimientoCOP =
    tarifas?.PrecioAnualMantenimiento && form.maquetaVirtual
      ? Math.round(Number(tarifas.PrecioAnualMantenimiento))
      : 0;

  // Subtotal base
  let subtotal = precioSitioWebCOP + precioAnualMantenimientoCOP;

  if (!tarifas) return { subtotal: 0, total: 0 };

  // Suma campos por cantidad
  subtotal += (parseInt(form.renderPlantasTipoTorre, 10) || 0) * (tarifas.RenderPlantasTipoTorre || 0);
  subtotal += (parseInt(form.renderPlantaAptoTipico, 10) || 0) * (tarifas.RenderPlantaAptoTipico || 0);
  subtotal += (parseInt(form.plantasArquitectonicasCotas, 10) || 0) * (tarifas.PlantasArquitectonicasConCotasAptoTipico || 0);
  subtotal += (parseInt(form.renderInteriores, 10) || 0) * (tarifas.RenderInteriores || 0);
  subtotal += (parseInt(form.renderExterior, 10) || 0) * (tarifas.RenderExterior || 0);
  subtotal += (parseInt(form.renderFotomontaje, 10) || 0) * (tarifas.RenderFotomontaje || 0);
  subtotal += (parseInt(form.renderAmenties, 10) || 0) * (tarifas.RenderAmenties || 0);
  subtotal += (parseInt(form.interiores360, 10) || 0) * (tarifas.Interiores360xNodo || 0);
  subtotal += (parseInt(form.videos, 10) || 0) * (tarifas.VideosVuelosTransicionesParaLaIntrox7De3Seg || 0);
  subtotal += (parseInt(form.vueloTorre * form.numeroTorres || 0) || 0) * (tarifas.AnimacionVueloATorre || 0);
  subtotal += (parseInt((form.rendersDisponibilidad * form.numeroTorres || 0), 10) || 0) * (tarifas.RendersStillsParaDisponiblidad || 0);
  subtotal += (parseInt(form.animacionLuma, 10) || 0) * (tarifas.AnimacionParaLumaIA || 0);
  subtotal += (parseInt(form.animacionIntro, 10) || 0) * (tarifas.AnimacionIntro || 0);
  subtotal += (parseInt(form.videoAnimacion, 10) || 0) * (tarifas.VideoAnimacion || 0);
  subtotal += ComisionFinal;

  if (form.incluirVueloDrone && form.vueloDrone && !isNaN(form.vueloDrone)) {
    subtotal += Number(form.vueloDrone);
  }

  // Descuento
  let descuento = 0;
  if (form.descuentoValor && !form.descuentoPorcentaje) {
    descuento = Number(form.descuentoValor);
  } else if (form.descuentoPorcentaje && !form.descuentoValor) {
    descuento = subtotal * (Number(form.descuentoPorcentaje) / 100);
  }

  const baseNeta = Math.max(0, subtotal - descuento);

  const aplicarIVA = form.retencionIVA || false;
  const aplicarReteFuente = form.retencionReteFuente || false;
  const aplicarReteICA = form.retencionReteICA || false;
  const aplicarReteIVA = form.retencionReteIVA || false;

  const iva = aplicarIVA ? baseNeta * 0.19 : 0;
  const reteFuente = aplicarReteFuente ? baseNeta * 0.025 : 0;
  const reteICA = aplicarReteICA ? baseNeta * 0.009 : 0;
  const reteIVA = aplicarReteIVA ? iva * 0.15 : 0;

  const total = Math.max(0, Math.round(baseNeta + iva - reteFuente - reteICA - reteIVA));

  return {
    subtotal: Math.round(subtotal),
    baseNeta: Math.round(baseNeta),
    iva: Math.round(iva),
    reteFuente: Math.round(reteFuente),
    reteICA: Math.round(reteICA),
    reteIVA: Math.round(reteIVA),
    total,
    descuento: Math.round(descuento),
    cantidadUnidades,
    precioCOPUnidades,
    tarifaTransferencia: tarifaTransferenciaCOP,
    baseParaServicioTerceros,
    precioSitioWeb: precioSitioWebCOP,
    precioAnualMantenimiento: precioAnualMantenimientoCOP,
  };
}
